import React from "react";
import { useParams } from "react-router-dom";
import { MarkListStudentMonthWise } from "../../components/MarkListStudentMonthWise";
import Layout from "../../components/shared/Layout/Layout";

const MarkListStudentMonthlyPage = () => {
  const { id } = useParams();
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title="Student Mark Monthly">
        <MarkListStudentMonthWise id={id} />
      </Layout>
    </div>
  );
};

export default MarkListStudentMonthlyPage;
